import request from "@/utils/request";

export function uploadImg (data){
  return request({
    url:'/osp/articleSettings/image/upload',
    method:'post',
    data: data
  })
}

export function saveArticle (data){
  return request({
    url:'/osp/articleSettings/saveBo',
    method:'post',
    data: data
  })
}

export function updateArticle (data){
  return request({
    url:'/osp/articleSettings/updateByBo',
    method:'post',
    data: data
  })
}
export function deleteArticleByIds (data){
  return request({
    url:'/osp/articleSettings/deleteByIds',
    method:'post',
    data: data
  })
}

export function queryArticlePageList (data){
  return request({
    url:'/osp/articleSettings/queryPageList',
    method:'post',
    data: data
  })
}

export function queryArticleById (data){
  return request({
    url:'/osp/articleSettings/queryById',
    method:'post',
    data: data
  })
}
